import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

@Component({
  selector: 'lib-custom-snackbar',
  standalone: true,
  imports: [MatIconModule, CommonModule],
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.scss'],
})
export class CustomSnackbarComponent {
  snackBarRef = inject(MatSnackBarRef);
  data: {
    message: string | { description: string }[];
    type: 'success' | 'error' | 'info' | 'warning';
    top?: string;
    icon?: string;
  } = inject(MAT_SNACK_BAR_DATA);

  get icon(): string {
    if (this.data?.icon) {
      return this.data.icon;
    }
    if (this.data?.type === 'success') {
      return 'check_circle';
    }
    if (this.data?.type === 'info') {
      return 'info';
    }
    if (this.data?.type === 'warning') {
      return 'warning';
    }
    return 'error';
  }

  get message(): string | { description: string }[] {
    return this.data.message;
  }

  isString(value: any): value is string {
    return typeof value === 'string';
  }

  dismiss() {
    this.snackBarRef.dismiss();
  }
}
